










































































import Vue from "vue";
export default Vue.extend({
  name: "CountTable",
  props: {
    overview: {
      default: (): object => ({})
    }
  }
});
